export enum ClockingSide {
  In = "in",
  Out = "out",
}
